import * as React from "react";

interface IProps {
  validLength: boolean;
  upperCase: boolean;
  lowerCase: boolean;
  specialChar: boolean;
  numericChar: boolean;
}

export const PasswordValidationRules = (props: IProps) => {
  const { validLength, upperCase, lowerCase, specialChar, numericChar } = props;
  return (
    <ul>
      <li>
        {validLength ? null : (
          <div>
            <span className="text-danger">
              Invalid: Minimum 10 characters.
            </span>
          </div>
        )}
      </li>
      <li>
        {upperCase ? null : (
          <span className="text-danger">
            Invalid: At least one uppercase.
          </span>
        )}
      </li>
      <li>
        {lowerCase ? null : (
          <span className="text-danger">
            Invalid: At least one lowercase.
          </span>
        )}
      </li>
      <li>
        {numericChar ? null : (
          <span className="text-danger">
            Invalid: At least one number.
          </span>
        )}
      </li>
      <li>
        {specialChar ? null : (
          <span className="text-danger">
            Invalid: At least one special character (#?!@$%^&*-).
          </span>
        )}
      </li>
    </ul>
  );
};
